import { addressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import { css } from "styled-components";

const addressLineStyles = `
    font-size: ${TYPOGRAPHY.size.small};
    color: ${COLORS.text.dark} !important;
    line-height: 1.4;
`;

Object.assign(addressInfoDisplayStyles, {
    customerNameText: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    attentionText: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    companyNameText: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    address1Text: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    address2Text: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    address3Text: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    address4Text: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    cityStatePostalCodeText: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    countryText: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    phoneText: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    emailText: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
    faxText: {
        as: "p",
        css: css`
            ${addressLineStyles}
        `,
    },
});
